import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, getToken, clearToken } from "@/lib/api";
import ManageJoiners from "@/components/admin/ManageJoiners";

export default function ManageJoinersPage() {
  const [authed, setAuthed] = useState(getToken() ? null : false);
  useEffect(() => {
    if (!getToken()) return;
    api.get("/admin/verify").then(() => setAuthed(true)).catch(() => { clearToken(); setAuthed(false); });
  }, []);

  if (authed === false) return <Navigate to="/admin" replace />;
  if (authed === null) return <div className="text-zinc-500 text-sm">Loading…</div>;

  return (
    <div className="rise">
      <Link to="/admin" data-testid="back-to-admin" className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-white transition-colors">
        <ArrowLeft className="h-4 w-4" /> Admin
      </Link>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-4">Manage Joiners</h1>
      <p className="text-zinc-400 mt-2 text-sm md:text-base">Set each joiner's GoM, Fixed, Soft and Open member claims.</p>
      <div className="mt-8"><ManageJoiners /></div>
    </div>
  );
}
